// Feature: docs/features/ionm-frontend-list-support.md
import React, { useState, useEffect, useContext } from 'react';
import { callApi } from '../callApi'; 
import { AppContext } from '../components/AppContext';
import ReactMarkdown from 'react-markdown';
import RelevancyResults from './IONMMedicalNecessity';

import { 
    ChakraProvider, 
    Box, 
    Container,
    Grid, 
    GridItem, 
    Flex, 
    Image, 
    VStack, 
    HStack,
    Text, 
    Textarea, 
    Button, 
    Input, 
    FormLabel,
    FormControl,
    Spinner,
    Tab,
    Tabs,
    TabList,
    TabPanel,
    TabPanels,
    Divider,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Stack,
    StackDivider,
    Badge,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Heading,
    Link,
    useColorModeValue,
    Progress,
    List,
    ListItem,
    ListIcon,
    SimpleGrid,
    useToast
} from "@chakra-ui/react";
import { Table, Thead, Tbody, Tr, Th, Td, IconButton, Tag, TagLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure } from "@chakra-ui/react"
import { DownloadIcon, CheckCircleIcon, WarningIcon, ViewIcon } from '@chakra-ui/icons';

import { extendTheme } from '@chakra-ui/react';
import HeaderMenus from './HeaderMenus';
import { useLocation } from 'react-router-dom';
import ModernChat from './ModernChat';
import ChatToggle from './ChatToggle';

const colors = {
  brand: {
    900: '#8ECAE6', //light blue
    800: '#219EBC', //blue
    700: '#023047', //dark blue
    600: '#FFB703', //yellow
    500: '#FB8500' //orange
  },
};

// Extend the theme
const theme = extendTheme({ colors });

function CodeIOMNew() {
    const [jsonData, setJsonData] = useState('');
    const [caseId, setCaseId] = useState('');
    const [caseFiles, setCaseFiles] = useState([]);
    const [modernFiles, setModernFiles] = useState([]);
    const [otherData, setOtherData] = useState('');
    const [cpt1, setCpt1] = useState('');
    const [cpt1desc, setCpt1desc] = useState('');
    const [pdfUrl, setPdfUrl] = useState(null);
    const [resultsReceived, setResultsReceived] = useState(false);
    const [resultsmReceived, setResultsmReceived] = useState(false);
    const [cptData, setCptData] = useState('');
    const [cptmData, setCptmData] = useState('');
    const { accessToken } = useContext(AppContext);
    const [results, setResults] = useState(undefined);
    const [resultsValue, setResultsValue] = useState(undefined);
    const [codingInProgress, setCodingInProgress] = useState(false);
    const location = useLocation();
    const [chatSummaries, setChatSummaries] = useState(null);
    const [statusMapping, setStatusMapping] = useState({});
    const [selectedPayer, setSelectedPayer] = useState('cms');

    const [relevancyResults, setRelevancyResults] = useState({});
    const [relevancyErrors, setRelevancyErrors] = useState({});
    const [gettingRelevancyResults, setGettingRelevancyResults] = useState({});
    const [codingSummary, setCodingSummary] = useState(null);
    const [qualityCheck, setQualityCheck] = useState(null);
    const [admissionStatus, setAdmissionStatus] = useState(null);
    const [isAdmissionAnalyzing, setIsAdmissionAnalyzing] = useState(false);
    const [selectedDocUrl, setSelectedDocUrl] = useState(null);
    const [isDocLoading, setIsDocLoading] = useState(false);
    const toast = useToast();

    // Modal state for file content
    const { isOpen: isTextModalOpen, onOpen: onTextModalOpen, onClose: onTextModalClose } = useDisclosure();
    const [selectedTextFile, setSelectedTextFile] = useState(null);

    // Color mode values for consistent theming
    const cardBg = useColorModeValue('white', 'gray.700');
    const highlightColor = useColorModeValue('blue.50', 'blue.900');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const accentColor = useColorModeValue('blue.500', 'blue.300');
    const codeBlockBg = useColorModeValue('gray.50', 'gray.800');
    const supportingEvidenceBg = useColorModeValue('green.50', 'green.900');
    const conflictingEvidenceBg = useColorModeValue('red.50', 'red.900');

    const allModalities = [
      ['OTHER MODALITIES', 'BCR'],
      ['EEG_ECOG', 'EEG'],
      ['EEG_ECOG', 'ECOG'],
      ['MAPPING', 'Subcortical Motor Mapping'],
      ['MAPPING', 'Cortical Motor Mapping'],
      ['MAPPING', 'Language Mapping'],
      ['NEEDLE EMG', 'Upper Extremity'],
      ['NEEDLE EMG', 'Cranial Nerve'],
      ['NEEDLE EMG', 'Axial Muscles'],
      ['NEEDLE EMG', 'Lower Extremity'],
      ['NEEDLE EMG', 'Sacral Muscles'],
      ['VOCALIS EMG', 'Laryngeal EMG'],
      ['VOCALIS EMG', 'LAR'],
      ['BAER', 'BAERs'],
      ['MAPPING', 'Phase Reversal'],
      ['MAPPING', 'Dorsal Column Mapping'],
      ['OTHER MODALITIES', 'VEP'],
      ['MEP', 'Upper Extremity'],
      ['MEP', 'Lower Extremity'],
      ['MEP', 'TaMEPs'],
      ['OTHER MODALITIES', 'H-REFLEX'],
      ['MEP', 'D-Wave'],
      ['NEEDLE EMG', 'Pedicle Screw Testing'],
      ['NEEDLE EMG', 'Direct Nerve Stimulation'],
      ['SSEP', 'Upper Extremity'],
      ['SSEP', 'Lower Extremity'],
      ['SSEP', 'Peripheral Nerves'],
      ['NEEDLE EMG', 'Nerve Proximity'],
      ['MAPPING', 'Mapping Duration'],
      ['TO4', '(T04)'],
    ];

    const [testsRun, setTestsRun] = useState({
        SSEP: { isRun: false, data: "" },
        MEP: { isRun: false, data: "" },
        EMG: { isRun: false, data: "" },
        To4: { isRun: false, data: "" },
        BAER: { isRun: false, data: "" },
        NerveConduction: { isRun: false, data: "" },
        EEG: { isRun: false, data: "" },
        Other: { isRun: false, data: "" },
    });

    useEffect(() => {
      // Get case ID from URL parameters only
      const params = new URLSearchParams(location.search);
      const caseIdFromUrl = params.get('caseid');
      
      if (caseIdFromUrl) {
        setCaseId(caseIdFromUrl);
        handleCaseButtonClick(caseIdFromUrl);
      }
    }, [location]);

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        else return (bytes / 1048576).toFixed(1) + ' MB';
    };

    const handleFileDownload = async (file) => {
        try {
          const response = await callApi('/download_case_file', accessToken, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              case_id: caseId,
              file_id: file.id 
            }),
          });
    
          if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = file.file_name;
            document.body.appendChild(a);
            a.click();
            
            setTimeout(() => {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 100);
          } else {
            console.error('Failed to download file');
          }
        } catch (error) {
          console.error('Download failed', error);
        }
    };

    function getTestsRun(data) {
        const tests = {
          SSEP: { isRun: false, data: "" },
          MEP: { isRun: false, data: "" },
          EMG: { isRun: false, data: "" },
          To4: { isRun: false, data: "" },
          BAER: { isRun: false, data: "" },
          NerveConduction: { isRun: false, data: "" },
          EEG: { isRun: false, data: "" },
          Other: { isRun: false, data: "" },
        };
      
        const ssepCodes = new Set(["95925", "95926", "95938"]);
        const mepCodes = new Set(["95928", "95929", "95939"]);
        const emgCodes = new Set(["51785","95860", "95861", "95864", "95865", "95867", "95868", "95870", "95885", "95886", "95887", "EMG from chat"]);
        const to4Codes = new Set(["95999"]);
        const nerveConductionCodes = new Set(["95907", "95908", "95909", "95910", "95911", "95912", "95913"]);
        const baerCodes = new Set(["92653"]);
        const eegCodes = new Set([ "95822", "95955"]);
      
        for (const item of data) {
            const code = item.cpt_code;
            if (ssepCodes.has(code)) {
              tests.SSEP.isRun = true;
              tests.SSEP.data += item.reason + ' ';
            } else if (mepCodes.has(code)) {
              tests.MEP.isRun = true;
              tests.MEP.data += item.reason + ' ';
            } else if (emgCodes.has(code)) {
              tests.EMG.isRun = true;
              tests.EMG.data += item.reason + ' ';
            } else if (to4Codes.has(code)) {
              tests.To4.isRun = true;
              tests.To4.data += item.reason + ' ';
            } else if (baerCodes.has(code)) {
              tests.BAER.isRun = true;
              tests.BAER.data += item.reason + ' ';
            } else if (nerveConductionCodes.has(code)) {
              tests.NerveConduction.isRun = true;
              tests.NerveConduction.data += item.reason + ' ';
            } else if (eegCodes.has(code)) {
              tests.EEG.isRun = true;
              tests.EEG.data += item.reason + ' ';
            } else {
              tests.Other.isRun = true;
              tests.Other.data += item.reason + '\n';
            }
        }
              
        return tests;
    }

    const TestCard = ({ title, data, isTestRun, spanTwoColumns }) => {
        const lines = data.split('\n').map((line, index, array) => (
          <React.Fragment key={index}>
            <Text fontSize="sm">{line}</Text>
            {index !== array.length - 1 && <br />}
          </React.Fragment>
        ));
      
        return (
          <Card
            bg={isTestRun ? "green.500" : "gray.200"}
            color={isTestRun ? "white" : "black"}
            boxShadow="sm"
            gridColumn={spanTwoColumns ? "span 2" : null}
          >
            <CardBody>
              <Heading size="md" mb={2}>
                {title}
              </Heading>
              {lines}
            </CardBody>
          </Card>
        );
    };

    const getIonmPdf = async (caseId) => {
        try {
          const response = await callApi(`/generate_ionm_pdf/${caseId}`, accessToken, {
            method: 'GET',
          });
      
          if (response.ok) {
            const blob = await response.blob();
      
            // Create a link element and trigger the download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.download = `ionm_report_${caseId}.pdf`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          } else {
            console.error('Error generating IONM PDF');
          }
        } catch (error) {
          console.error('Error generating IONM PDF:', error);
          alert('Error generating IONM PDF. Please try again.');
        }
    };

    const handleMNClick = async (case_id, payer_name) => {
        console.log("getting case results for case_id: " + case_id);
        setRelevancyResults(prev => ({ ...prev, [payer_name]: null }));
        setRelevancyErrors(prev => ({ ...prev, [payer_name]: null }));
        setGettingRelevancyResults(prev => ({ ...prev, [payer_name]: true }));

        try {
            let response = await callApi('/ionm_process_case', accessToken, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    case_id: case_id,
                    payer_name: payer_name,
                })
            });
            let results = await response.json();
            setGettingRelevancyResults(prev => ({ ...prev, [payer_name]: false }));

            if (results.error) {
                setRelevancyErrors(prev => ({ ...prev, [payer_name]: results.error }));
            } else {
                setRelevancyResults(prev => ({ ...prev, [payer_name]: results }));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleFileClick = async (externalPatientId, fileType) => {
      try {
        const response = await callApi('/getfile', accessToken, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            external_patient_id: externalPatientId, 
            file_type: fileType 
          }),
        });
    
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const newTab = window.open(url, '_blank');
    
          if (newTab) {
            newTab.focus();
          } else {
            alert('Please allow pop-ups for this website.');
          }
    
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 100);
        } else {
          console.error('Error downloading file:', response.statusText);
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    };

    const handleDocView = async (file) => {
        setIsDocLoading(true);
        // Revoke previous URL to avoid memory leaks
        if (selectedDocUrl) {
            window.URL.revokeObjectURL(selectedDocUrl);
        }
        setSelectedDocUrl(null);

        try {
            const response = await callApi('/download_case_file', accessToken, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    case_id: caseId,
                    file_id: file.id,
                    disposition: 'inline'
                }),
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                setSelectedDocUrl(url);
            } else {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to load file');
            }
        } catch (error) {
            console.error('Error loading file:', error);
            toast({
                title: 'Failed to load file',
                description: error.message,
                status: 'error',
                duration: 5000,
            });
        } finally {
            setIsDocLoading(false);
        }
    };

    const handleCaseButtonClick = async (case_id) => {
        console.log("getting case results for case_id: " + case_id);
        try {
            // Fetch modern case details for files
            try {
                const detailsResponse = await callApi(`/get_case_details/${case_id}`, accessToken);
                if (detailsResponse.ok) {
                    const details = await detailsResponse.json();
                    if (details.files) {
                        setModernFiles(details.files);
                    }
                }
            } catch (error) {
                console.error('Error fetching modern case details:', error);
            }

            let response = await callApi('/getcase', accessToken, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({case_id: case_id})
            });
            let results = await response.json();
    
            // Check if the response contains an error code
            if (results.error === 'Case not found') {
              console.error('No case found with id ' + case_id);
              return;
            }
            
            //update jsonData and otherData
            if (results.system_summary) {
                setJsonData(JSON.stringify(results.system_summary, null, 2));
            }
            if (results.case_files) {
              setCaseFiles(results.case_files);
            }
            setOtherData(JSON.stringify(results.chat_summary, null, 2));
            setCaseId(case_id);
            setCpt1desc(null);
            setResults(results);
            setResultsValue(null);
            setQualityCheck(null);

            let dataType = "no_messages";
            setResultsReceived(false);
            setResultsmReceived(false);
            setPdfUrl(null);
            if (dataType === "no_messages") {
                setCptData(null);
                setCptmData(null);
                setCpt1(null);
                setCpt1desc(null);
            }
            
            setCodingInProgress(true);

            // Fetch coding summary for NCCI data
            try {
                const summaryResponse = await callApi(`/coding_summary/${case_id}`, accessToken);
                if (summaryResponse.ok) {
                    const summaryData = await summaryResponse.json();
                    setCodingSummary(summaryData);
                } else {
                    console.error("Failed to fetch coding summary");
                    setCodingSummary(null);
                }
            } catch (error) {
                console.error("Error fetching coding summary:", error);
                setCodingSummary(null);
            }

            // Fetch Admission Status
            try {
                const admissionResponse = await callApi(`/api/cases/${case_id}/admission-status`, accessToken);
                if (admissionResponse.ok) {
                    const admissionData = await admissionResponse.json();
                    setAdmissionStatus(admissionData);
                } else {
                    console.error("Failed to fetch admission status");
                    setAdmissionStatus(null);
                }
            } catch (error) {
                console.error("Error fetching admission status:", error);
                setAdmissionStatus(null);
            }
    
            const code_response = await callApi('/ionm_code_from_json', accessToken, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data_type: dataType,
                    case_id: case_id,
                    no_refresh: true,
                }),
            });
            const data = await code_response.json();
            if (!data.original) {
                return;
            }
            
            if (data.quality_check) {
                setQualityCheck(data.quality_check);
            }
            
            const dataArray = Array.isArray(data.original) ? data.original : Object.values(data.original || {});
            const Statuses = {};
            dataArray && dataArray.forEach(data => {
              data.child_modalities && data.child_modalities.forEach(modality => {
                Statuses[modality] = "yes";
              });
            });
            setStatusMapping(Statuses);
    
            const tests = getTestsRun(dataArray);
            setTestsRun(tests);
    
            const formattedCptData = [];
    
            for (const layer of ['tech', 'pro', 'original']) {
              formattedCptData.push(<Text key={layer + "-header"} fontSize="xl" color="3e81c3" textAlign="left" marginLeft={2}>{layer.charAt(0).toUpperCase() + layer.slice(1)}</Text>);
          
              // Handle both array (new format) and object (legacy format)
              let layerData = data[layer] || [];
              let itemsArray = Array.isArray(layerData) ? layerData : Object.values(layerData);
              
              // Sort based on the score
              const sortedItems = [...itemsArray].sort((a, b) => (b.score || 0) - (a.score || 0));
          
              sortedItems.forEach((cptData, index) => {
                  const cpt = cptData.cpt_code;
                  const desc = cptData.cpt_description;
                  let reason = cptData.reason || cptData.justification || '';
                  // if type is in cptData, then add "(preliminary) to the cpt code"
                  if (cptData.type === 'preliminary' && !cptData.cpt_code.includes('(needs review')) {
                      cptData.cpt_code += ' (needs review, please see Reason section)';
                  }
                  //display reason on web page with line breaks using jsx
                  const reasonLines = reason.split('\n');
                  
                  const jsxReasonLines = reasonLines.map((line, lineIndex) => (
                      <Text
                          key={lineIndex}
                          align="left"
                          ml={4}
                          fontSize="md"
                          fontWeight="normal"
                          backgroundColor={cptData.type === 'preliminary' ? 'lightcoral' : 'transparent'}
                      >
                          {line}
                      </Text>
                  ));
                  reason = jsxReasonLines;
          
                  if (cptData.result === false) {
                      return; // continue in forEach
                  }
          
                  const modifiersList = cptData.modifiers && cptData.modifiers.length > 0 
                      ? cptData.modifiers 
                      : (cptData.modifier ? [cptData.modifier] : []);
                  const modalitiesList = cptData.child_modalities || [];

                  // Format the CPT data as JSX
                  const jsxData = (
                      <Box key={`${cpt}-${layer}-${index}`} margin={4} p={4} borderWidth="1px" borderRadius="md" bg="white" shadow="sm">
                          <Flex justify="space-between" align="center" mb={2}>
                              <HStack>
                                  <Text fontSize="md" fontWeight="bold" color="blue.700">
                                      CPT: {cptData['cpt_code']}
                                  </Text>
                                  {modifiersList.map((mod, i) => (
                                      <Badge key={i} colorScheme="purple">{mod}</Badge>
                                  ))}
                              </HStack>
                              <HStack>
                                  {cptData['units'] && <Badge colorScheme="gray">Units: {cptData['units']}</Badge>}
                                  {cptData['total_duration'] && <Badge colorScheme="teal">Time: {cptData['total_duration']}</Badge>}
                                  {cptData['billable'] === false && <Badge colorScheme="red">Not Billable</Badge>}
                              </HStack>
                          </Flex>
                          
                          {modalitiesList.length > 0 && (
                              <Box mb={2}>
                                  <Text fontSize="xs" fontWeight="bold" color="gray.500" display="inline" mr={2}>MODALITIES:</Text>
                                  {modalitiesList.map((mod, i) => (
                                      <Tag key={i} size="sm" colorScheme="blue" variant="subtle" mr={1} mb={1}>{mod}</Tag>
                                  ))}
                              </Box>
                          )}
                          
                          <Text fontSize="sm" color="gray.700" mb={2}><strong>Description:</strong> {desc}</Text>
                          <Box fontSize="sm" color="gray.700"><strong>Reason:</strong> {reason}</Box>
                      </Box>
                  );
          
                  // Add the formatted data to the array
                  formattedCptData.push(jsxData);
              });
            }
          
            setCpt1('');
            setCpt1desc(formattedCptData);            
            setResultsReceived(true);
            setResultsValue(JSON.stringify(data.original));
            setCodingInProgress(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setPdfUrl(null);
    
        const response = await callApi('/ionm_cpt_cms1500', accessToken, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cpt_1: cpt1,
            }),
        });
    
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        // Store the URL in a state variable
        setPdfUrl(url);
    };

    const runAdmissionAnalysis = async () => {
        setIsAdmissionAnalyzing(true);
        try {
          const response = await callApi(`/api/cases/${caseId}/run-analysis`, accessToken, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              analysis_type: 'ADMISSION_STATUS',
              force_rerun: true,
            }),
          });
    
          const data = await response.json();
    
          if (!response.ok || data.status !== 'success') {
            throw new Error(data.message || 'Failed to run analysis.');
          }
    
          const newResultsPayload = {
            status: 'success',
            case_id: data.case_id,
            admission_status: data.results,
            metadata: {
              extracted_at: new Date().toISOString(),
              is_current: true,
            },
          };
    
          setAdmissionStatus(newResultsPayload);
          toast({
            title: 'Analysis Complete',
            description: 'Admission status has been re-analyzed successfully.',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        } catch (err) {
          console.error('Error running analysis:', err);
          toast({
            title: 'Analysis Failed',
            description: err.message,
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        } finally {
          setIsAdmissionAnalyzing(false);
        }
    };

    const getConfidenceAttributes = (score) => {
        if (score >= 8) return { colorScheme: 'green', level: 'High' };
        if (score >= 5) return { colorScheme: 'yellow', level: 'Medium' };
        return { colorScheme: 'red', level: 'Low' };
    };

    // Helper to parse evidence quotes
    const parseEvidenceQuote = (quote) => {
        if (!quote) return { text: '', source: null };
        
        const trimmedQuote = quote.trim();
        if (!trimmedQuote.endsWith(')')) {
            return { text: quote, source: null };
        }

        // Scan backwards to find the balancing opening parenthesis
        let balance = 0;
        let openParenIndex = -1;

        for (let i = trimmedQuote.length - 1; i >= 0; i--) {
            const char = trimmedQuote[i];
            if (char === ')') {
                balance++;
            } else if (char === '(') {
                balance--;
                if (balance === 0) {
                    openParenIndex = i;
                    break;
                }
            }
        }

        if (openParenIndex > 0) {
            return {
                text: trimmedQuote.substring(0, openParenIndex).trim(),
                source: trimmedQuote.substring(openParenIndex + 1, trimmedQuote.length - 1).trim()
            };
        }
        
        return { text: quote, source: null };
    };

    // Helper to normalize filenames for comparison
    const normalizeFilename = (name) => {
        if (!name) return '';
        return name.toLowerCase()
            .replace(/documents_\d+_?/gi, '')  // Remove "Documents_123456_" prefix
            .replace(/[_\/]+/g, ' ')           // Replace underscores and slashes with spaces
            .replace(/\s+/g, ' ')              // Collapse multiple spaces
            .replace(/\(\w\)/g, '')            // Optional: remove (A), (B) if they cause issues, but keeping them is usually better if they match. 
                                               // Actually, let's keep (A) but ensure spacing is consistent.
            .trim();
    };

    // Helper to find matching file
    const findMatchingFile = (sourceName) => {
        if (!sourceName || !modernFiles) return null;
        
        // 1. Try exact match
        let match = modernFiles.find(f => f.file_name === sourceName);
        if (match) return match;

        // 2. Try case-insensitive match
        match = modernFiles.find(f => f.file_name.toLowerCase() === sourceName.toLowerCase());
        if (match) return match;

        // 3. Try normalized match
        const normSource = normalizeFilename(sourceName);
        
        // Find all potential matches
        const potentialMatches = modernFiles.filter(f => {
            const normFile = normalizeFilename(f.file_name);
            return normSource === normFile || 
                   normSource.includes(normFile) || 
                   normFile.includes(normSource);
        });

        if (potentialMatches.length > 0) {
            // Sort by length of the match (longer filename match is likely more specific)
            // or pick the one that is closest in length to the source?
            // Let's pick the one with the longest file_name to avoid matching "Report.pdf" against "Full Report.pdf" incorrectly if possible,
            // but usually we want the most specific match.
            // Actually, if normSource includes normFile, we want the longest normFile (covers most of the source).
            potentialMatches.sort((a, b) => b.file_name.length - a.file_name.length);
            return potentialMatches[0];
        }
        
        return null;
    };

    const EvidenceItem = ({ quote, type }) => {
        const { text, source } = parseEvidenceQuote(quote);
        const matchingFile = findMatchingFile(source);
        const bg = type === 'supporting' ? supportingEvidenceBg : conflictingEvidenceBg;
        const icon = type === 'supporting' ? CheckCircleIcon : WarningIcon;
        const iconColor = type === 'supporting' ? "green.500" : "red.500";

        return (
            <ListItem bg={bg} p={3} borderRadius="md">
                <VStack align="start" spacing={1}>
                    <Box>
                        <ListIcon as={icon} color={iconColor} mt={1} />
                        <Text display="inline">"{text}"</Text>
                    </Box>
                    {source && (
                        <Box pl={6}>
                            <Text fontSize="xs" color="gray.500" as="span" mr={1}>Source:</Text>
                            {matchingFile ? (
                                <Link 
                                    color="blue.600" 
                                    fontSize="xs" 
                                    fontWeight="medium"
                                    onClick={() => handleDocView(matchingFile)}
                                >
                                    {source}
                                </Link>
                            ) : (
                                <Text fontSize="xs" as="span" fontStyle="italic">{source}</Text>
                            )}
                        </Box>
                    )}
                </VStack>
            </ListItem>
        );
    };

    return (
      <ChakraProvider theme={theme}>
        <Box>
          <HeaderMenus />
          <Container maxW="container.xl" py={8}>
            
            {/* Page Header */}
            <Flex justify="space-between" align="center" mb={6}>
              <Heading as="h1" size="lg">IONM Case Analysis</Heading>
              <HStack spacing={4}>
                <Text fontSize="md" fontWeight="medium">Case ID: {caseId || 'Not loaded'}</Text>
              </HStack>
            </Flex>

            {/* Loading State */}
            {codingInProgress && (
              <Alert status="info" mb={6} borderRadius="md">
                <AlertIcon />
                <Spinner size="sm" mr={3} />
                <AlertTitle>Processing Case</AlertTitle>
                <AlertDescription>Coding analysis in progress...</AlertDescription>
              </Alert>
            )}

            {/* Main Content Tabs */}
            <Tabs variant="enclosed" colorScheme="blue">
              <TabList>
                <Tab>Case Information</Tab>
                <Tab>Test Results</Tab>
                <Tab>Modalities</Tab>
                <Tab>Coding Results</Tab>
                <Tab>NCCI Analysis</Tab>
                <Tab>Admission Status</Tab>
                <Tab>Raw Data</Tab>
                <Tab>Chat History</Tab>
                <Tab>Chat</Tab>
                <Tab>CMS 1500 Form</Tab>
              </TabList>

              <TabPanels>
                {/* Case Information Tab */}
                <TabPanel>
                  {results && (
                    <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                      {/* Patient Information Card */}
                      <Card variant="outline" bg={cardBg}>
                        <CardHeader>
                          <Heading size="md">Patient Information</Heading>
                        </CardHeader>
                        <CardBody>
                          <Stack spacing={3}>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Patient Name</Text>
                              <Text>{results.patient_first_name} {results.patient_last_name}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Primary Patient ID</Text>
                              <Text>{results.external_patient_id}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Cadwell Patient ID</Text>
                              <Text>{results.external_patient_id_secondary}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Case Name</Text>
                              <Text>{results.case_name}</Text>
                            </Box>
                          </Stack>
                        </CardBody>
                      </Card>

                      {/* Case Details Card */}
                      <Card variant="outline" bg={cardBg}>
                        <CardHeader>
                          <Heading size="md">Case Details</Heading>
                        </CardHeader>
                        <CardBody>
                          <Stack spacing={3}>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Procedure Date</Text>
                              <Text>{results.procedure_date}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Initial Process Date</Text>
                              <Text>{results.create_date}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Recent Process Date</Text>
                              <Text>{results.updated_at}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Case ID</Text>
                              <Text>{results.case_id}</Text>
                            </Box>
                          </Stack>
                        </CardBody>
                      </Card>

                      {/* Payer Information Card */}
                      <Card variant="outline" bg={cardBg}>
                        <CardHeader>
                          <Heading size="md">Payer Information</Heading>
                        </CardHeader>
                        <CardBody>
                          <Stack spacing={3}>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Payer</Text>
                              <HStack>
                                <Text>{results.payer || 'N/A'}</Text>
                                {!results.payer && (
                                  <Badge colorScheme="red" size="sm">Missing</Badge>
                                )}
                              </HStack>
                            </Box>
                            <Box>
                              <Text fontWeight="bold" fontSize="sm" color="gray.600">Carrier</Text>
                              <Text>{results.carrier}</Text>
                            </Box>
                          </Stack>
                        </CardBody>
                      </Card>

                      {/* Quick Actions Card */}
                      <Card variant="outline" bg={cardBg}>
                        <CardHeader>
                          <Heading size="md">Quick Actions</Heading>
                        </CardHeader>
                        <CardBody>
                          <Stack spacing={3}>
                            <Link 
                              href={`/ionm-strict-analysis/${results.case_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              color={accentColor}
                              fontWeight="medium"
                            >
                              Medical Necessity Analysis →
                            </Link>

                            <Link 
                              href={`/case-appeals/${results.case_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              color={accentColor}
                              fontWeight="medium"
                            >
                              View Case Appeals →
                            </Link>
                            
                            </Stack>
                        </CardBody>
                      </Card>

                      {/* Case Files Card */}
                      {(modernFiles && modernFiles.length > 0) || (caseFiles && caseFiles.length > 0) ? (
                        <Card variant="outline" bg={cardBg} gridColumn={{ lg: "span 2" }}>
                          <CardHeader>
                            <Heading size="md">Case Files</Heading>
                          </CardHeader>
                          <CardBody>
                            {modernFiles && modernFiles.length > 0 ? (
                              <Grid templateColumns="30% 70%" gap={6} height="600px">
                                {/* Left Column: File List */}
                                <GridItem overflowY="auto" pr={2} borderRight="1px" borderColor={borderColor}>
                                  <VStack align="stretch" spacing={2}>
                                    {modernFiles.map((file) => (
                                      <Box
                                        key={file.id}
                                        p={3}
                                        cursor="pointer"
                                        borderRadius="md"
                                        bg={selectedDocUrl && selectedDocUrl.includes(file.id) ? "blue.50" : "transparent"}
                                        _hover={{ bg: "gray.50" }}
                                        borderWidth="1px"
                                        borderColor={selectedDocUrl && selectedDocUrl.includes(file.id) ? "blue.200" : "transparent"}
                                        onClick={() => handleDocView(file)}
                                      >
                                        <Flex justify="space-between" align="start">
                                          <VStack align="start" spacing={1} flex="1">
                                            <Text fontSize="sm" fontWeight="medium" noOfLines={2} title={file.file_name}>
                                              {file.file_name}
                                            </Text>
                                            <HStack>
                                              <Tag size="sm" colorScheme="blue" variant="subtle">
                                                <TagLabel fontSize="xs">{file.file_type}</TagLabel>
                                              </Tag>
                                              <Text fontSize="xs" color="gray.500">
                                                {formatFileSize(file.file_size)}
                                              </Text>
                                            </HStack>
                                          </VStack>
                                          <HStack spacing={1}>
                                            <IconButton
                                              icon={<ViewIcon />}
                                              size="xs"
                                              variant="ghost"
                                              colorScheme="blue"
                                              aria-label="View file text"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedTextFile(file);
                                                onTextModalOpen();
                                              }}
                                            />
                                            <IconButton
                                              icon={<DownloadIcon />}
                                              size="xs"
                                              variant="ghost"
                                              colorScheme="blue"
                                              aria-label="Download file"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleFileDownload(file);
                                              }}
                                            />
                                          </HStack>
                                        </Flex>
                                      </Box>
                                    ))}
                                  </VStack>
                                </GridItem>

                                {/* Right Column: Document Viewer */}
                                <GridItem bg="gray.100" borderRadius="md" borderWidth="1px" position="relative" height="100%">
                                  {isDocLoading ? (
                                    <Flex justify="center" align="center" h="100%">
                                      <VStack>
                                        <Spinner size="xl" color="blue.500" />
                                        <Text>Loading Document...</Text>
                                      </VStack>
                                    </Flex>
                                  ) : selectedDocUrl ? (
                                    <iframe 
                                      src={selectedDocUrl} 
                                      title="Document Viewer"
                                      width="100%" 
                                      height="100%" 
                                      style={{ border: 'none', borderRadius: '4px' }} 
                                    />
                                  ) : (
                                    <Flex justify="center" align="center" h="100%" color="gray.500" flexDirection="column">
                                      <Text fontSize="lg">Select a file to view</Text>
                                      <Text fontSize="sm">Click a file from the list on the left</Text>
                                    </Flex>
                                  )}
                                </GridItem>
                              </Grid>
                            ) : (
                              <Box>
                                <Text fontWeight="bold" fontSize="sm" color="gray.600" mb={2}>Legacy Files</Text>
                                <Stack spacing={1}>
                                  {caseFiles.map((file, index) => (
                                    <Link
                                      key={index}
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleFileClick(results.external_patient_id, file);
                                      }}
                                      color={accentColor}
                                      fontSize="sm"
                                    >
                                      {file}
                                    </Link>
                                  ))}
                                </Stack>
                              </Box>
                            )}
                          </CardBody>
                        </Card>
                      ) : null}
                    </Grid>
                  )}
                  
                  {!results && (
                    <Alert status="info" borderRadius="md">
                      <AlertIcon />
                      <AlertDescription>
                        No case loaded. Please provide a case ID in the URL parameters.
                      </AlertDescription>
                    </Alert>
                  )}
                </TabPanel>

                {/* Test Results Tab */}
                <TabPanel>
                  <Box mb={6}>
                    <Heading size="md" mb={4}>Test Summary</Heading>
                    <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={4}>
                      <TestCard title="SSEP" data={testsRun.SSEP.data} isTestRun={testsRun.SSEP.isRun} />
                      <TestCard title="MEP" data={testsRun.MEP.data} isTestRun={testsRun.MEP.isRun} />
                      <TestCard title="EMG" data={testsRun.EMG.data} isTestRun={testsRun.EMG.isRun} />
                      <TestCard title="Train of Four" data={testsRun.To4.data} isTestRun={testsRun.To4.isRun} />
                      <TestCard title="BAER" data={testsRun.BAER.data} isTestRun={testsRun.BAER.isRun} />
                      <TestCard title="Nerve Conduction" data={testsRun.NerveConduction.data} isTestRun={testsRun.NerveConduction.isRun} />
                      <TestCard title="EEG" data={testsRun.EEG.data} isTestRun={testsRun.EEG.isRun} />
                      <TestCard title="Other" data={testsRun.Other.data} isTestRun={testsRun.Other.isRun} spanTwoColumns />
                    </Grid>
                  </Box>
                </TabPanel>

                {/* Modalities Tab */}
                <TabPanel>
                  {cpt1desc && (
                    <Card variant="outline" bg={cardBg}>
                      <CardHeader>
                        <Heading size="md">Active Modalities</Heading>
                      </CardHeader>
                      <CardBody>
                        <Table variant="simple" size="sm">
                          <Thead>
                            <Tr>
                              <Th>Parent Modality</Th>
                              <Th>Child Modality</Th>
                              <Th>Status</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {allModalities
                              .filter(([parentModality, childModality]) => {
                                const status = statusMapping[`${parentModality}:${childModality}`] || "";
                                return status === 'yes';
                              })
                              .map(([parentModality, childModality], index) => (
                                <Tr key={index}>
                                  <Td>
                                    <Text fontSize="sm" fontWeight="medium">{parentModality}</Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize="sm">{childModality}</Text>
                                  </Td>
                                  <Td>
                                    <Badge colorScheme="green" size="sm">Active</Badge>
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </CardBody>
                    </Card>
                  )}
                  
                  {!cpt1desc && (
                    <Alert status="info" borderRadius="md">
                      <AlertIcon />
                      <AlertDescription>
                        No modality data available. Please load a case and run the analysis.
                      </AlertDescription>
                    </Alert>
                  )}
                </TabPanel>

                {/* Coding Results Tab */}
                <TabPanel>
                  {qualityCheck && qualityCheck.status === 'needs_review' && (
                    <Alert status="warning" mb={6} borderRadius="md" flexDirection="column" alignItems="flex-start">
                      <HStack mb={2}>
                        <AlertIcon />
                        <AlertTitle>Quality Check: Needs Review</AlertTitle>
                      </HStack>
                      <AlertDescription whiteSpace="pre-wrap" pl={7}>
                        {qualityCheck.review_text}
                      </AlertDescription>
                    </Alert>
                  )}
                  {resultsReceived && cpt1desc && (
                    <Card variant="outline" bg={cardBg}>
                      <CardHeader>
                        <Heading size="md">CPT Coding Results</Heading>
                      </CardHeader>
                      <CardBody>
                        <Box>
                          {cpt1desc}
                        </Box>
                        
                        <Divider my={6} />
                        
                        <form onSubmit={handleFormSubmit}>
                          <Button colorScheme="blue" type="submit" size="lg">
                            Generate CMS 1500 Form
                          </Button>
                        </form>
                      </CardBody>
                    </Card>
                  )}
                  
                  {!resultsReceived && !codingInProgress && (
                    <Alert status="info" borderRadius="md">
                      <AlertIcon />
                      <AlertDescription>
                        No coding results available. Please load a case to see the analysis.
                      </AlertDescription>
                    </Alert>
                  )}
                </TabPanel>

                {/* NCCI Analysis Tab */}
                <TabPanel>
                  {codingSummary ? (
                    <VStack spacing={6} align="stretch">
                      {['pro_ncci', 'tech_ncci'].map((type) => {
                        const data = codingSummary.adjusted_codes?.[type];
                        if (!data) return null;
                        
                        const title = type === 'pro_ncci' ? 'Professional Fee (NCCI Adjusted)' : 'Technical Fee (NCCI Adjusted)';
                        
                        // Convert codes object/array to array and sort
                        const sourceData = data.adjusted_codes || data.cpt_codes || data || {};
                        const codesArray = (Array.isArray(sourceData)
                          ? sourceData.map(details => ({ code: details.cpt_code, ...details }))
                          : Object.entries(sourceData).map(([key, details]) => ({
                              code: details.cpt_code || key,
                              ...details
                            }))
                        ).sort((a, b) => (a.code || '').localeCompare(b.code || ''));

                        // Filter for justifications
                        const justificationCodes = codesArray.filter(item => 
                            item.justification && 
                            !item.justification.toLowerCase().startsWith("no conflicts found")
                        );

                        return (
                          <Card key={type} variant="outline" bg={cardBg}>
                            <CardHeader>
                              <Heading size="md">{title}</Heading>
                            </CardHeader>
                            <CardBody>
                              {codesArray.length > 0 ? (
                                <Table variant="simple" size="sm">
                                  <Thead>
                                    <Tr>
                                      <Th>CPT Code</Th>
                                      <Th>Description</Th>
                                      <Th>Units</Th>
                                      <Th>Modifiers</Th>
                                      <Th>Result</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {codesArray.map((item, idx) => (
                                      <Tr key={idx}>
                                        <Td fontWeight="bold">{item.code}</Td>
                                        <Td>{item.cpt_description || item.description || '-'}</Td>
                                        <Td>{item.units || 1}</Td>
                                        <Td>
                                          {item.modifiers && item.modifiers.length > 0 ? (
                                            item.modifiers.map((mod, i) => (
                                              <Badge key={i} colorScheme="blue" mr={1}>{mod}</Badge>
                                            ))
                                          ) : item.modifier ? (
                                            <Badge colorScheme="blue">{item.modifier}</Badge>
                                          ) : '-'}
                                        </Td>
                                        <Td>
                                          {item.result !== undefined ? (
                                            <Badge colorScheme={item.result ? 'green' : 'red'}>
                                              {item.result ? 'Allowed' : 'Denied'}
                                            </Badge>
                                          ) : '-'}
                                        </Td>
                                      </Tr>
                                    ))}
                                  </Tbody>
                                </Table>
                              ) : (
                                <Text color="gray.500">No codes found for this category.</Text>
                              )}

                              {justificationCodes.length > 0 && (
                                <Box mt={6}>
                                  <Divider mb={4} />
                                  <Heading size="sm" mb={3}>Justifications</Heading>
                                  <VStack align="stretch" spacing={3}>
                                    {justificationCodes.map((item, idx) => (
                                      <Box key={idx}>
                                        <Text fontSize="sm">
                                          <Text as="span" fontWeight="bold" color="blue.600">
                                            {item.code}:
                                          </Text>{" "}
                                          {item.justification}
                                        </Text>
                                      </Box>
                                    ))}
                                  </VStack>
                                </Box>
                              )}
                            </CardBody>
                          </Card>
                        );
                      })}
                      
                      {!codingSummary.adjusted_codes?.pro_ncci && !codingSummary.adjusted_codes?.tech_ncci && (
                         <Alert status="warning" borderRadius="md">
                           <AlertIcon />
                           <AlertDescription>
                             No NCCI adjusted data found for this case.
                           </AlertDescription>
                         </Alert>
                      )}
                    </VStack>
                  ) : (
                    <Alert status="info" borderRadius="md">
                      <AlertIcon />
                      <AlertDescription>
                        {codingInProgress ? "Loading NCCI data..." : "No NCCI data available. Please load a case."}
                      </AlertDescription>
                    </Alert>
                  )}
                </TabPanel>

                {/* Admission Status Tab */}
                <TabPanel>
                  <Card variant="outline" bg={cardBg}>
                    <CardHeader>
                      <HStack justify="space-between">
                        <Heading size="md">Admission Status Analysis</Heading>
                        <Button
                          colorScheme="blue"
                          size="sm"
                          onClick={runAdmissionAnalysis}
                          isLoading={isAdmissionAnalyzing}
                          loadingText="Analyzing..."
                          isDisabled={!caseId}
                        >
                          {admissionStatus && admissionStatus.status !== 'not_found' ? 'Re-run Analysis' : 'Run Analysis'}
                        </Button>
                      </HStack>
                    </CardHeader>
                    <CardBody>
                      {admissionStatus && admissionStatus.status !== 'not_found' ? (
                        <VStack spacing={6} align="stretch">
                          {/* Primary Status and Confidence */}
                          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                              <Card bg={cardBg} borderColor={borderColor} p={4} variant="outline">
                                  <Text fontSize="sm" fontWeight="bold" color="gray.500">PRIMARY STATUS</Text>
                                  <Text fontSize="2xl" fontWeight="bold" color="blue.600">{admissionStatus.admission_status.primary_status || 'Unknown'}</Text>
                              </Card>
                              <Card bg={cardBg} borderColor={borderColor} p={4} variant="outline">
                                  <Text fontSize="sm" fontWeight="bold" color="gray.500">RECOMMENDED POS</Text>
                                  <Text fontSize="2xl" fontWeight="bold" color="blue.600">{admissionStatus.admission_status.recommended_pos_code || 'N/A'}</Text>
                              </Card>
                              <Card bg={cardBg} borderColor={borderColor} p={4} variant="outline">
                                  <Text fontSize="sm" fontWeight="bold" color="gray.500">CONFIDENCE</Text>
                                  <HStack mt={2}>
                                      <Progress 
                                        value={admissionStatus.admission_status.confidence * 10} 
                                        colorScheme={getConfidenceAttributes(admissionStatus.admission_status.confidence).colorScheme} 
                                        size="lg" 
                                        flex="1" 
                                        borderRadius="md" 
                                      />
                                      <Badge 
                                        colorScheme={getConfidenceAttributes(admissionStatus.admission_status.confidence).colorScheme} 
                                        fontSize="md"
                                      >
                                        {getConfidenceAttributes(admissionStatus.admission_status.confidence).level} ({admissionStatus.admission_status.confidence}/10)
                                      </Badge>
                                  </HStack>
                              </Card>
                          </SimpleGrid>

                          <Divider />

                          {/* Evidence & Document Viewer Split */}
                          <Grid templateColumns="35% 65%" gap={6} minHeight="600px">
                            {/* Left Column: Evidence Lists */}
                            <GridItem overflowY="auto" maxHeight="800px" pr={2}>
                                <VStack spacing={6} align="stretch">
                                    {/* Supporting Evidence */}
                                    <Box>
                                        <Heading size="sm" mb={2}>Supporting Evidence</Heading>
                                        {admissionStatus.admission_status.supporting_evidence && admissionStatus.admission_status.supporting_evidence.length > 0 ? (
                                            <List spacing={3}>
                                                {admissionStatus.admission_status.supporting_evidence.map((quote, index) => (
                                                    <EvidenceItem key={index} quote={quote} type="supporting" />
                                                ))}
                                            </List>
                                        ) : (
                                            <Text color="gray.500" fontStyle="italic">No supporting evidence found.</Text>
                                        )}
                                    </Box>

                                    {/* Conflicting Evidence */}
                                    <Box>
                                        <Heading size="sm" mb={2}>Conflicting Evidence</Heading>
                                        {admissionStatus.admission_status.conflicting_evidence && admissionStatus.admission_status.conflicting_evidence.length > 0 ? (
                                            <List spacing={3}>
                                                {admissionStatus.admission_status.conflicting_evidence.map((quote, index) => (
                                                    <EvidenceItem key={index} quote={quote} type="conflicting" />
                                                ))}
                                            </List>
                                        ) : (
                                            <Text color="gray.500" fontStyle="italic">No conflicting evidence found.</Text>
                                        )}
                                    </Box>
                                </VStack>
                            </GridItem>

                            {/* Right Column: Document Viewer */}
                            <GridItem bg="gray.100" borderRadius="md" borderWidth="1px" position="relative" height="800px">
                                {isDocLoading ? (
                                    <Flex justify="center" align="center" h="100%">
                                        <VStack>
                                            <Spinner size="xl" color="blue.500" />
                                            <Text>Loading Document...</Text>
                                        </VStack>
                                    </Flex>
                                ) : selectedDocUrl ? (
                                    <iframe 
                                        src={selectedDocUrl} 
                                        title="Document Viewer"
                                        width="100%" 
                                        height="100%" 
                                        style={{ border: 'none', borderRadius: '4px' }} 
                                    />
                                ) : (
                                    <Flex justify="center" align="center" h="100%" color="gray.500" flexDirection="column">
                                        <Text fontSize="lg">Select a document to view</Text>
                                        <Text fontSize="sm">Click a source link in the evidence list or a file below</Text>
                                    </Flex>
                                )}
                            </GridItem>
                          </Grid>

                          <Divider />

                          {/* Bottom Section: All Case Documents */}
                          <Box>
                            <Heading size="md" mb={4}>All Case Documents</Heading>
                            <Card variant="outline" bg="gray.50">
                                <CardBody>
                                    {modernFiles && modernFiles.length > 0 ? (
                                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                                            {modernFiles.map((file) => (
                                                <Button
                                                    key={file.id}
                                                    size="sm"
                                                    variant="ghost"
                                                    justifyContent="flex-start"
                                                    onClick={() => handleDocView(file)}
                                                    _hover={{ bg: "blue.50" }}
                                                    whiteSpace="normal"
                                                    height="auto"
                                                    py={2}
                                                    textAlign="left"
                                                    borderWidth="1px"
                                                    borderColor="gray.200"
                                                    bg="white"
                                                >
                                                    <VStack align="start" spacing={0} width="100%">
                                                        <Text fontWeight="medium" noOfLines={1}>{file.file_name}</Text>
                                                        <HStack justify="space-between" width="100%">
                                                            <Tag size="sm" colorScheme="blue" fontSize="xs">
                                                                {file.file_type}
                                                            </Tag>
                                                            <Text fontSize="xs" color="gray.500">
                                                                {formatFileSize(file.file_size)}
                                                            </Text>
                                                        </HStack>
                                                    </VStack>
                                                </Button>
                                            ))}
                                        </SimpleGrid>
                                    ) : (
                                        <Text fontSize="sm" color="gray.500">No documents found.</Text>
                                    )}
                                </CardBody>
                            </Card>
                          </Box>

                        </VStack>
                      ) : (
                        <Alert status="info" borderRadius="md">
                          <AlertIcon />
                          <AlertDescription>
                            {isAdmissionAnalyzing ? "Analyzing admission status..." : "No admission status analysis found. Click 'Run Analysis' to generate."}
                          </AlertDescription>
                        </Alert>
                      )}
                    </CardBody>
                  </Card>
                </TabPanel>

                {/* Raw Data Tab */}
                <TabPanel>
                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    {/* System Data */}
                    <Card variant="outline" bg={cardBg}>
                      <CardHeader>
                        <Heading size="md">System Data</Heading>
                      </CardHeader>
                      <CardBody>
                        <FormControl>
                          <Textarea
                            value={jsonData.replace(/\\n/g, '\n')}
                            readOnly
                            rows={20}
                            fontSize="sm"
                            fontFamily="monospace"
                            bg="gray.50"
                          />
                        </FormControl>
                      </CardBody>
                    </Card>

                    {/* Message Data */}
                    <Card variant="outline" bg={cardBg}>
                      <CardHeader>
                        <Heading size="md">Message Data</Heading>
                      </CardHeader>
                      <CardBody>
                        <FormControl>
                          <Textarea
                            value={otherData}
                            onChange={e => setOtherData(e.target.value)}
                            rows={20}
                            fontSize="sm"
                            fontFamily="monospace"
                            bg="gray.50"
                          />
                        </FormControl>
                      </CardBody>
                    </Card>
                  </Grid>
                </TabPanel>

                {/* Chat & Feedback Tab */}
                <TabPanel>
                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    {/* Existing Feedback */}
                    <Card variant="outline" bg={cardBg}>
                      <CardHeader>
                        <Heading size="md">Existing Feedback</Heading>
                      </CardHeader>
                      <CardBody>
                        {chatSummaries ? (
                          <Stack spacing={4}>
                            {Object.entries(chatSummaries)
                              .sort((a, b) => new Date(b[1].created_at) - new Date(a[1].created_at))
                              .map(([chatId, summary], index) => (
                                <Box key={index} p={3} borderWidth="1px" borderRadius="md">
                                  <Text fontSize="sm" fontWeight="bold">{summary.email}</Text>
                                  <Text fontSize="xs" color="gray.500">{summary.created_at}</Text>
                                </Box>
                              ))}
                          </Stack>
                        ) : (
                          <Text color="gray.500">No feedback available</Text>
                        )}
                      </CardBody>
                    </Card>

                  </Grid>
                </TabPanel>

                {/* Modern Feedback Tab */}
                <TabPanel>
                  <Card variant="outline" bg={cardBg}>
                    <CardHeader>
                      <Heading size="md">Modern Chat Assistant</Heading>
                    </CardHeader>
                    <CardBody>
                      {caseId ? (
                        <ModernChat 
                          caseId={caseId} 
                          contextType="cpt_ionm_context" 
                          height="600px"
                        />
                      ) : (
                        <Alert status="info" borderRadius="md">
                          <AlertIcon />
                          <AlertDescription>
                            Please load a case to use the Modern AI Assistant.
                          </AlertDescription>
                        </Alert>
                      )}
                    </CardBody>
                  </Card>
                </TabPanel>

                {/* CMS 1500 Form Tab */}
                <TabPanel>
                  {pdfUrl ? (
                    <Card variant="outline" bg={cardBg}>
                      <CardHeader>
                        <Heading size="md">CMS 1500 Form</Heading>
                      </CardHeader>
                      <CardBody>
                        <Box height="800px" width="100%">
                          <iframe 
                            src={pdfUrl} 
                            width="100%" 
                            height="100%" 
                            style={{ border: 'none', borderRadius: '8px' }}
                          />
                        </Box>
                      </CardBody>
                    </Card>
                  ) : (
                    <Alert status="info" borderRadius="md">
                      <AlertIcon />
                      <AlertDescription>
                        Generate the CMS 1500 form from the Coding Results tab to view it here.
                      </AlertDescription>
                    </Alert>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Container>

          {/* Footer */}
          <Box
            bg='white'
            borderTop='1px'
            borderColor={borderColor}
            py={4}
            px={6}
            mt={8}
          >
            <Flex justifyContent="center" alignItems="center">
              <Image src="/images/revedy_logo.png" alt="Revedy" height="15px" />
              <Text fontSize="sm" color="gray.600" ml={2}>
                &copy; {new Date().getFullYear()}
              </Text>
            </Flex>
          </Box>

          {/* Chat Toggle */}
          <ChatToggle
            contextType={'revedy'}
            contextData={'revedy_ionm_coding'}
            contextPersona={'revedy_ionm_coding'}
            firstMessage={"Hi, what can I do on this page?"}
            useOptions={false}
            maintainContext={true}
            contextMode={'popup'}
          />

          {/* File Content Modal */}
          <Modal isOpen={isTextModalOpen} onClose={onTextModalClose} size="xl">
            <ModalOverlay />
            <ModalContent maxW="800px">
              <ModalHeader>
                {selectedTextFile?.file_name}
                <Tag size="sm" colorScheme="blue" ml={2} mt={-1}>
                  <TagLabel>{selectedTextFile?.file_type}</TagLabel>
                </Tag>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Box 
                  p={4} 
                  borderWidth="1px" 
                  borderRadius="md" 
                  bg="gray.50" 
                  maxH="500px" 
                  overflowY="auto"
                  whiteSpace="pre-wrap"
                  fontFamily="monospace"
                >
                  {selectedTextFile?.file_text || "No content available"}
                </Box>
              </ModalBody>
              <ModalFooter>
                <Text fontSize="sm" color="gray.500" mr="auto">
                  {selectedTextFile ? formatFileSize(selectedTextFile.file_size) : ""} • 
                  {selectedTextFile ? " Uploaded " + (selectedTextFile.upload_date ? new Date(selectedTextFile.upload_date).toLocaleDateString() : "Unknown") : ""}
                </Text>
                <Button colorScheme="blue" mr={3} onClick={onTextModalClose}>
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      </ChakraProvider>
    );
};

export default CodeIOMNew;
